module.exports = __webpack_public_path__ + "imgs/mjfreeway.e18f95b80a2687e87e2c6cdfd62c10bc.jpg";